var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTableSimple',_vm._g(_vm._b({attrs:{"selected":_vm.value,"headers":_vm.headers,"actions":_vm.actions},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var header = ref.header;
var item = ref.item;
return [_c('router-link',{attrs:{"to":header.getRoute(item)},domProps:{"textContent":_vm._s(item.name)}})]}}])},'BTableSimple',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }